module.exports = __webpack_public_path__ + "media/images/logo-67731fd6996a74c47b07012682d3c316.png";